// import React, { useEffect, useState } from "react";
// import useHttp from "../../../../hook/use-http"; import { Chart } from 'react-google-charts';
// import NoData from "../../NoData";
// import ChartLoader from '../../ChartLoader';
// import CommanBarTable_Orion from "../CommanBarTable_Orion";
// import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
// import WaterMark from "../../DashboardMain_Orion/WaterMark";
// import { BsZoomIn } from "react-icons/bs";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   scales,
//   Ticks
// } from "chart.js";
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );
// let Maxchartdata
// let res_result = []

// function AverageChargeCurrentVehicles_Orion({ apiend, gloablfilter, type, chartnameFCD }) {
//   const [chartdata, setChartData] = useState([]);
//   const [apiresponce, SetApiResponce] = useState([]);
//   const [filteredData, SetfilteredData] = useState([]);
//   const { isLoading, error, sendReq: fetchData } = useHttp();
//   const [chartname, SetChartName] = useState(chartnameFCD);
//   let barcolor = "#83A4CF"

//   const appyDataVehicles = (data) => {
//     res_result = []
//     res_result = data;
//     let responce = {
//       "<=90": 0,
//       "120": 0,
//       "150": 0,
//       "180": 0,
//       "210": 0,
//       "240": 0,
//       "270": 0,
//       "300": 0,
//       "330": 0,
//       ">330": 0,
//     };
//     if (res_result.length !== 0) {
//       let temp_result = res_result;
//       let id = 0
//       let newapiarray = []
//       SetApiResponce(res_result)
//       temp_result.map(d => {
//         let value = d.median_avgChargingCurrent.values["50.0"];
//         if (value != null) {
//           if (value > 0 && value <= 90) {
//             responce["<=90"] = responce["<=90"] + 1;
//           } else if (value > 90 && value <= 120) {
//             responce["120"] = responce["120"] + 1;
//           } else if (value > 120 && value <= 150) {
//             responce["150"] = responce["150"] + 1;
//           } else if (value > 150 && value <= 180) {
//             responce["180"] = responce["180"] + 1;
//           } else if (value > 180 && value <= 210) {
//             responce["210"] = responce["210"] + 1;
//           } else if (value > 210 && value <= 240) {
//             responce["240"] = responce["240"] + 1;
//           } else if (value > 240 && value <= 270) {
//             responce["270"] = responce["270"] + 1;
//           } else if (value > 270 && value <= 300) {
//             responce["300"] = responce["300"] + 1;
//           } else if (value > 300 && value <= 330) {
//             responce["330"] = responce["330"] + 1;
//           } else if (value > 330) {
//             responce[">330"] = responce[">330"] + 1;
//           }
//         }
//       })

//       let res_result_final = [["Element", "Count", { role: "style" }]]
//       const loop_keys = ["<=90", "120", "150", "180", "210", "240", "270", "300", "330", ">330"]
//       let countcheck = 0
//       for (const key in responce) {
//         if (responce[key] > 0) {
//           countcheck = countcheck + 1
//         }
//       }

//       loop_keys.map(x => {
//         if (countcheck)
//           // "#83A4CF"
//           res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
//       })

//       const labels = ["<=90", "120", "150", "180", "210", "240", "270", "300", "330", ">330"]
//       Maxchartdata = {
//         labels,
//         datasets: [
//           {
//             label: "Amps",
//             data: responce,
//             backgroundColor: barcolor,
//             borderWidth: 1,
//             borderColor: "black",
//           },
//         ]
//       };
//       setChartData((prestate) => res_result_final);
//     } else {
//       setChartData((prestate) => []);
//     }
//   }

//   const options1 = {
//     responsive: true,
//     categoryPercentage: 1.0,
//     barPercentage: 1.0,
//     scales: {
//       x: {
//         grid: {
//           color: 'white',
//         },
//         title: {
//           display: true,
//           text: 'Amps'
//         },
//         suggestedMin: 0,
//         ticks: {
//           autoSkip: false,
//           maxRotation: 0,
//           minRotation: 0,
//         }
//       },

//       y: {
//         grid: {
//           color: 'white',
//         },
//         title: {
//           display: true,
//           text: 'Vehicle Count'
//         },
//         suggestedMin: 0,
//       },
//     },

//     plugins: {
//       legend: {
//         display: false
//       },
//     }
//   }

//   const options = {
//     hAxis: {
//       gridlines: {
//         color: 'transparent'
//       },
//       title: 'Amps',
//       minValue: 0,
//       format: 'short',
//       direction: 1,
//       slantedText: true,
//       slantedTextAngle: 90,
//     },

//     vAxis: {
//       gridlines: {
//         color: 'transparent'
//       },
//       title: 'Vehicle Count',
//       minValue: 0,
//       format: 'short',
//     },
//     bar: { groupWidth: "100%" },
//     legend: "none",
//     isStacked: false,
//     series: {
//       0: { color: "#83A4CF" },
//     },
//   };

//   useEffect(() => {
//     barcolor = "#83A4CF"
//     SetChartName("Avg Charging Current");
//     fetchData({ url: API_URL_MAIN + "orion_charging_analysis/" + apiend, body: { filterdata: gloablfilter } }, appyDataVehicles)
//   }, [gloablfilter, type])

//   return (
//     <>
//       <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
//         <div className="modal-dialog modal-lg">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
//               <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
//             </div>
//             <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
//               {
//                 (isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
//                   : <NoData />
//                 )}
//             </div>
//           </div>
//         </div>
//       </div>

//       <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>
//       <WaterMark />

//       {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" width="100%" height="200px" data={chartdata} options={options} chartEvents={[
//         {
//           eventName: 'select',
//           callback: ({ chartWrapper }) => {
//             const chart = chartWrapper.getChart()
//             const selection = chart.getSelection()
//             if (selection.length === 1) {
//               const [selectedItem] = selection;
//               const { row } = selectedItem;

//               const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
//               const count = chartWrapper.getDataTable().Wf[row].c[1].v;

//               let filtered_temp = [];
//               if (count !== 0) {
//                 filtered_temp = apiresponce.filter(x => {
//                   if (x.median_avgChargingCurrent.values["50.0"] <= barvalue && x.median_avgChargingCurrent.values["50.0"] > barvalue - 30) {
//                     return x;
//                   }
//                   else if (x.median_avgChargingCurrent.values["50.0"] > 330 && barvalue === ">330") {
//                     return x
//                   }
//                   else if (x.median_avgChargingCurrent.values["50.0"] <= 90 && barvalue === "<=90") {
//                     return x
//                   }
//                 })

//                 function compareObjects(object1, object2, key) {
//                   let obj1 = 0
//                   let obj2 = 0
//                   obj1 = object1.median_avgChargingCurrent.values["50.0"]
//                   obj2 = object2.median_avgChargingCurrent.values["50.0"]
//                   if (obj1 > obj2) {
//                     return -1
//                   }
//                   if (obj1 < obj2) {
//                     return 1
//                   }
//                   return 0
//                 }

//                 filtered_temp.sort((value1, value2) => {
//                   return compareObjects(value1, value2, 'value')
//                 })
//                 SetfilteredData(prestate => filtered_temp);
//                 window.$('#exampleModal__' + apiend).modal('show');
//               }
//             }
//           }
//         }
//       ]}
//       /> : <NoData />)}

//       <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
//         <div className="modal-dialog modal-lg">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
//               <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
//             </div>
//             {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}> */}
//             <div className="modal-body">
//               {/* style={{ overflowY: 'scroll', height: '250px' }} */}
//               {/* <table className="table table-striped">
//                 <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
//                   <tr>
//                     <th scope="col">Vin Number</th>
//                     <th scope="col">Value</th>
//                     <th scope="col">Reg No</th>
//                     <th scope="col">Depot</th>
//                     <th scope="col">City</th>
//                   </tr></thead>
//                 <tbody> */}
//               <CommanBarTable_Orion data={filteredData} tabDataKey={"median_avgChargingCurrent"} />
//               {/* </tbody></table> */}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default AverageChargeCurrentVehicles_Orion;


import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http"; 
import { Chart } from 'react-google-charts';
import NoData from "../../NoData";
import ChartLoader from '../../ChartLoader';
import CommanBarTable_Orion from "../CommanBarTable_Orion";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import WaterMark from "../../DashboardMain_Orion/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales,
  Ticks
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

let Maxchartdata
let res_result = []

function AverageChargeCurrentVehicles_Orion({ apiend, gloablfilter, type, chartnameFCD }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [chartname, SetChartName] = useState(chartnameFCD);
  let barcolor = "#83A4CF"

  const appyDataVehicles = (data) => {
    res_result = []
    res_result = data;
    let responce = {
      "25": 0,
      "50": 0,
      "75": 0,
      "100": 0,
      "125": 0,
      "150": 0,
      ">150": 0,
    };

    if (res_result.length !== 0) {
      let temp_result = res_result;
      SetApiResponce(res_result)
      temp_result.map(d => {
        let value = d.median_avgChargingCurrent.values["50.0"];
        if (value != null) {
          if (value > 0 && value <= 25) {
            responce["25"] += 1;
          } else if (value > 25 && value <= 50) {
            responce["50"] += 1;
          } else if (value > 50 && value <= 75) {
            responce["75"] += 1;
          } else if (value > 75 && value <= 100) {
            responce["100"] += 1;
          } else if (value > 100 && value <= 125) {
            responce["125"] += 1;
          } else if (value > 125 && value <= 150) {
            responce["150"] += 1;
          } else if (value > 150) {
            responce[">150"] += 1;
          }
        }
      })

      let res_result_final = [["Element", "Count", { role: "style" }]]
      const loop_keys = ["25", "50", "75", "100", "125", "150", ">150"]
      let countcheck = 0
      for (const key in responce) {
        if (responce[key] > 0) {
          countcheck += 1
        }
      }

      loop_keys.map(x => {
        if (countcheck)
          res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
      })

      const labels = ["25", "50", "75", "100", "125", "150", ">150"]
      Maxchartdata = {
        labels,
        datasets: [
          {
            label: "Amps",
            data: responce,
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },
        ]
      };
      setChartData(res_result_final);
    } else {
      setChartData([]);
    }
  }

  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Amps'
        },
        suggestedMin: 0,
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        }
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Vehicle Count'
        },
        suggestedMin: 0,
      },
    },

    plugins: {
      legend: {
        display: false
      },
    }
  }

  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Amps',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90,
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Vehicle Count',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: "#83A4CF" },
    },
  };

  useEffect(() => {
    barcolor = "#83A4CF"
    SetChartName("Avg Charging Current");
    fetchData({ url: API_URL_MAIN + "orion_charging_analysis/" + apiend, body: { filterdata: gloablfilter } }, appyDataVehicles)
  }, [gloablfilter, type])

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {
                (isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
                  : <NoData />
                )}
            </div>
          </div>
        </div>
      </div>

      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>
      <WaterMark />

      {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" width="100%" height="200px" data={chartdata} options={options} chartEvents={[
        {
          eventName: 'select',
          callback: ({ chartWrapper }) => {
            const chart = chartWrapper.getChart()
            const selection = chart.getSelection()
            if (selection.length === 1) {
              const [selectedItem] = selection;
              const { row } = selectedItem;

              const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
              const count = chartWrapper.getDataTable().Wf[row].c[1].v;

              let filtered_temp = [];
              if (count !== 0) {
                filtered_temp = apiresponce.filter(x => {
                  const val = x.median_avgChargingCurrent.values["50.0"];
                  if (barvalue === ">150" && val > 150) return x;
                  else if (barvalue === "25" && val > 0 && val <= 25) return x;
                  else if (barvalue === "50" && val > 25 && val <= 50) return x;
                  else if (barvalue === "75" && val > 50 && val <= 75) return x;
                  else if (barvalue === "100" && val > 75 && val <= 100) return x;
                  else if (barvalue === "125" && val > 100 && val <= 125) return x;
                  else if (barvalue === "150" && val > 125 && val <= 150) return x;
                })

                function compareObjects(object1, object2, key) {
                  let obj1 = 0
                  let obj2 = 0
                  obj1 = object1.median_avgChargingCurrent.values["50.0"]
                  obj2 = object2.median_avgChargingCurrent.values["50.0"]
                  if (obj1 > obj2) return -1
                  if (obj1 < obj2) return 1
                  return 0
                }

                filtered_temp.sort((value1, value2) => {
                  return compareObjects(value1, value2, 'value')
                })
                SetfilteredData(prestate => filtered_temp);
                window.$('#exampleModal__' + apiend).modal('show');
              }
            }
          }
        }
      ]}
      /> : <NoData />)}

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">
              <CommanBarTable_Orion data={filteredData} tabDataKey={"median_avgChargingCurrent"} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AverageChargeCurrentVehicles_Orion;
